import styled, { css } from "styled-components"
import Breakpoints from "../shared/breakpoints"
import TextStyles from "../shared/typography.styles"
import Img from "gatsby-image"

export const Container = styled.div`
  padding: 48px 0;

  @media (min-width: ${Breakpoints.md}) {
    padding: 64px 0;
  }

  @media (min-width: ${Breakpoints.lg}) {
    padding: 96px 0;
  }
`

export const OverviewContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-column: 1 / -1;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    align-items: flex-start;
    :nth-child(2) {
      grid-column: -6 / -2;
    }
    :nth-child(5) {
      grid-column: 2 / 6;
    }
  }
`

export const LogoRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;

  @media (min-width: ${Breakpoints.lg}) {
    justify-content: flex-start;
  }
`

export const Logo = styled.img`
  margin: 0 8px;
  width: 32px;
  height: 32px;
  @media (min-width: ${Breakpoints.lg}) {
    width: 48px;
    height: 48px;
    margin: 0 16px 0 0;
  }
`

export const Title = styled.h2`
  ${TextStyles.mobileTextStyles.MobileHeadingTwoBold}
  color: var(--slate);
  margin-top: 16px;
  text-align: center;

  & > b {
    text-transform: lowercase;
  }

  @media (min-width: ${Breakpoints.md}) {
    ${TextStyles.tabletTextStyles.TabletHeadingTwoBold}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${TextStyles.desktopTextStyles.HeadingTwoBold}
    margin-top: 24px;
    text-align: left;
  }
`

export const TextContent = styled.p`
  ${TextStyles.mobileTextStyles.MobileBodyRegular}
  text-align: center;
  color: var(--body-text-grey);
  margin-top: 24px;

  @media (min-width: ${Breakpoints.md}) {
    ${TextStyles.tabletTextStyles.TabletBodyRegular}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${TextStyles.desktopTextStyles.BodyText18}
    text-align: left;
  }
`

export const WebSdkImage = styled(Img)`
  grid-column: 2 / -2;
  width: 100%;
  max-width: 75vw;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 4 / -4;
    max-width: 47vw;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 1 / 7;
    max-width: 560px;
    justify-self: center;
  }
`

export const MobileSdkImageContainer = styled.div`
  grid-column: 2 / -2;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 4 / -4;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 7 / -1;

    align-self: center;
    grid-row: 3;
  }
`

export const MobileSdkImage = styled(Img)`
  width: 100%;
  max-width: 750px;
`

export const Spacer = styled.div`
  grid-column: 1 / -1;
  margin-top: 64px;
  @media (min-width: ${Breakpoints.md}) {
    margin-top: 96px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 128px;
  }
`

export const LinkContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 16px;
  grid-column-gap: 12px;
  margin-top: 32px;

  & + & {
    margin-top: 16px;
  }

  @media (min-width: ${Breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-template-columns: 1fr;
    justify-items: left;
    grid-gap: 0;
  }
`

export const SdkLinkContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  margin-top: 32px;

  @media (min-width: ${Breakpoints.md}) {
    width: 50%;
  }
  @media (min-width: ${Breakpoints.lg}) {
    justify-items: left;
  }
`

export const DarkButtonStyle = css`
  @media (min-width: ${Breakpoints.lg}) {
    color: var(--burnt-orange);
    margin: 0;
    padding: 0;
    background-color: transparent;
    border: none;
    ${TextStyles.desktopTextStyles.HeadingSixRegular}
    ::after {
      content: " >";
      margin-left: 12px;
    }
    :first-child {
      margin-right: 48px;
    }
  }
`

export const ButtonStyle = css`
  ${DarkButtonStyle}
  background-color: var(--white);
  color: var(--burnt-orange);
  border: 1px solid var(--burnt-orange);
`
